<template>
  <!-- Pantalla inicio: consumidor financiero -->
  <div class="w-12/12 m-auto flex flex-col items-center container-workspace">
    <h2
      class="w-full text-2xl sm:text-2xl md:text-4xl text-left text-blue-dark mb-4"
    >
      <b>¡Bienvenido, {{ name }}!</b>
    </h2>
    <h2
      v-if="showEnvironmentText"
      class="text-xl xl:text-2xl 4xl:text-4xl uppercase text-left environment-text mb-4"
    >
      <b
        >Este entorno de pruebas está diseñado para evaluar nuevas
        funcionalidades y realizar pruebas. Para acceder al entorno de
        producción,
        <a
          href="https://smart.superfinanciera.gov.co"
          class="environment-text underline"
          >haga clic aquí</a
        ></b
      >
    </h2>
    <p
      class="w-full text-md md:text-lg lg:text-xl mt-2 mb-5 text-left text-gray-500"
    >
      ¿Qué desea hacer?
    </p>
    <!-- Opciones -->
    <div
      class="w-full max-w-8xl flex flex-col justify-center items-center lg:flex-row gap-8"
    >
      <!-- Opción: Queja -->
      <router-link
        to="./complaint/registration"
        class="m-5 max-w-md sm:w-4/5 md:w-3/5 mx-auto my-5 flex flex-col self-stretch bg-white rounded-2xl shadow-md cursor-pointer"
        append
      >
        <div class="p-5 border-b-4 border-blue-dark h-3/6 w-full">
          <div
            class="h-14 w-14 m-auto flex justify-center items-center rounded-full bg-white border-2"
          >
            <img src="@/assets/icons/file.svg" alt="" />
          </div>
          <h3
            class="mt-2 text-blue-dark text-center text-xl md:text-2xl justify-between"
          >
            <b>Presentar una queja</b>
          </h3>
        </div>
        <div class="h-3/6 w-full p-4 mb-3 flex flex-col justify-between">
          <p class="p-5 text-sm text-gray-600">
            Suministre la información relacionada con su inconformidad frente a
            un producto o servicio del sistema financiero.
          </p>
          <a-button
            type="primary"
            shape="round"
            :block="true"
            aria-label="Diligenciar formulario para presentar una queja"
            title="Diligenciar formulario para presentar una queja"
          >
            DILIGENCIAR FORMULARIO
          </a-button>
        </div>
      </router-link>

      <!-- Opción: Seguir queja -->
      <router-link
        to="./complaint/tracking"
        class="m-5 max-w-md sm:w-4/5 md:w-3/5 mx-auto my-5 flex flex-col self-stretch bg-white rounded-2xl shadow-md cursor-pointer"
        append
      >
        <div class="p-5 border-b-4 border-blue-dark h-3/6 w-full">
          <div class="h-14 w-14 m-auto flex rounded-full bg-white border-2">
            <img src="@/assets/icons/eye.svg" alt="" />
          </div>
          <h3
            class="h-4/6 mt-2 text-blue-dark text-xl md:text-2xl justify-center flex items-center"
          >
            <b>Seguimiento de quejas</b>
          </h3>
        </div>
        <div class="h-3/6 w-full p-4 mb-3 flex flex-col justify-between">
          <p class="p-5 text-sm text-gray-600 justify-between">
            Estado actual de una o más inconformidades presentadas con
            anterioridad.
          </p>
          <a-button
            type="primary"
            shape="round"
            :block="true"
            aria-label="Hacer seguimiento de quejas"
            title="Hacer seguimiento de quejas"
          >
            HACER SEGUIMIENTO
          </a-button>
        </div>
      </router-link>

      <!-- Opción: Queja contra un emisor de valores -->
      <router-link
        to="./complaint-emisor/confirm"
        class="m-5 max-w-md sm:w-4/5 md:w-3/5 mx-auto my-5 flex flex-col self-stretch bg-white rounded-2xl shadow-md cursor-pointer"
        append
      >
        <div class="p-5 border-b-4 border-blue-dark h-3/6 w-full">
          <div
            class="h-14 w-14 m-auto flex justify-center items-center rounded-full bg-white border-2"
          >
            <img src="@/assets/icons/file.svg" alt="" />
          </div>
          <h3
            class="mt-2 text-blue-dark text-center text-xl md:text-2xl justify-between"
          >
            <b>Quejas emisores de valores (RNVE)</b>
          </h3>
        </div>
        <div class="h-3/6 w-full p-4 mb-3 flex flex-col justify-between">
          <p class="p-5 text-sm text-gray-600">
            Espacio exclusivo para quejas sobre emisores – RNVE
          </p>
          <a-button
            type="primary"
            shape="round"
            :block="true"
            aria-label="Diligenciar formulario para presentar una queja"
            title="Diligenciar formulario para presentar una queja"
          >
            DILIGENCIAR FORMULARIO
          </a-button>
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showEnvironmentText: false,
    };
  },
  created() {
    if (
      process.env.VUE_APP_SHOW_TEST_ENVIRONMENT_MSG &&
      process.env.VUE_APP_SHOW_TEST_ENVIRONMENT_MSG === "true"
    ) {
      this.showEnvironmentText = true;
    }
  },
  components: {},
  computed: {
    name() {
      if (this.$store.state.session.user) {
        let name =
          this.$store.state.session?.user?.person?.person_type === 2
            ? this.$store.state.session.user.business_name
            : this.$store.state.session.user.first_name;
        return name;
      }
      return "";
    },
  },
};
</script>

<style scoped>
.environment-text {
  color: #ffa02a;
}

.environment-text:hover {
  color: #ffa02a;
}
</style>
